import React from 'react';
import classNames from 'classnames/bind';
import { DataBlocks } from 'components';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import PropTypes from 'prop-types';
import styles from './styles.pcss';
import {
  getTariffsBlockBtnText, getTariffsBlockDescription,
  getTariffsBlockShow, getTariffsBlockTitle, getTariffsBlockUrl,
} from '../../selectors';
const cn = classNames.bind(styles);

const TariffsBlock = ({ href, title, btnText, description }) => (
  <DataBlocks.Block
    title={title}
    links={[{
      children: btnText,
      href,
    }]}
    className={cn('wrapper')}
  >
    {description}
  </DataBlocks.Block>
);

const mapStateToProps = (state) => ({
  href: getTariffsBlockUrl(state),
  title: getTariffsBlockTitle(state),
  btnText: getTariffsBlockBtnText(state),
  description: getTariffsBlockDescription(state),
  shouldRender: getTariffsBlockShow(state),
});

TariffsBlock.propTypes = {
  href: PropTypes.string,
  title: PropTypes.string,
  btnText: PropTypes.string,
  description: PropTypes.string,
};

export default compose(
  connect(mapStateToProps),
  withRenderFlag,
)(TariffsBlock);
